import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    margin: 0 0 20px;
    padding-bottom: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #e7e7f0;
`;

export const LogosWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex: 1;
`;

export const AckoLogoWrapper = styled.div`
    display: flex;
    align-items: center;
    flex: 0 0 auto;
`;

export const PartnerLogoWrapper = styled.div`
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    height: 26px;
    gap: 8px;
`;

export const PartnerLogoDivider = styled.div`
    width: 1px;
    height: 20px;
    background: #e7e7f0;
    flex-shrink: 0;
`;

export const PartnerLogoImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    max-width: 120px;

    img {
        width: auto !important;
        height: 22px !important;
        max-width: 120px;
        object-fit: contain;
        object-position: left center;
    }
`;

export const HamburgerWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const RightControls = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const GroupSwitchWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`;

export const GroupSwitchButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #000000;
    background: #ffffff;
    color: #000000;
    border-radius: 12px;
    padding: 8px 14px;
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
`;

export const GroupSwitchIcon = styled.span`
    font-size: 16px;
    line-height: 1;
`;

export const GroupSwitchText = styled.span`
    white-space: nowrap;
`;

export const GroupDropdown = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    min-width: 180px;
    background: #ffffff;
    border: 1px solid #d7d7de;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(16, 18, 35, 0.12);
    padding: 6px;
    z-index: 20;
`;

export const GroupDropdownItem = styled.button<{ isActive: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    border: 0;
    border-radius: 8px;
    background: ${({ isActive }) => (isActive ? '#f3f5f7' : '#ffffff')};
    color: #101223;
    padding: 10px 12px;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    font-weight: ${({ isActive }) => (isActive ? 700 : 500)};

    &:hover {
        background: #f3f5f7;
    }
`;
